// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1lilk","content":"ManualTimeModal_content__Du0eV"};